export default {
  httpApi: ['https://test.lifeapp.net'],
  appSettings: {
    tus: true,
    tusd: true, // nodejs server or GO tusd server
    chunkSize: 10 * 1024 * 1024,
    parallelUploads: 5,
    endpoint: 'https://test.lifeapp.net/tusd/'
  },
  websocket: {
    url: `wss://test.lifeapp.net:8981/sockjs`,
    api: 'https://test.lifeapp.net',
    pingInterval: 5 * 1000,
    maxPingInterval: 20 * 1000,
    maxWaitingForcePing: 5 * 1000
  }
};
